import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/ai-statement"
    exact
    path="/consumer/ai-statement"
    component={AsyncPage}
  />,
];
